import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "../utils/prefixStyles";
import DialogBackground from "./DialogBackground";
import Theme from "../Theme";
import Button from "../Button";
import { IconClose } from "../Icons";
import BackButtonResponder from "../BackButtonResponder";
import MountOnBody from "../MountOnBody";
import Tappable from "../Tappable";
import NoStyleButton from "../NoStyleButton";

const styles = {
  root: prefixStyles({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
  }),
  closeButtonWrapper: {
    position: "absolute",
    top: "-1.5em",
    right: "-1.5em",
    fontSize: "0.5em",
    padding: "1em", // increased click area
    cursor: "pointer",
  },
  closeIcon: {
    fontSize: "0.5em",
  },
};
export default class Dialog extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    onTapBackground: PropTypes.func,
    open: PropTypes.bool,
    docked: PropTypes.bool,
    noCloseButton: PropTypes.bool,
    onRequestClose: PropTypes.func,
    noFocusOnOpen: PropTypes.bool,
  };

  componentDidMount() {
    if (!this.props.noFocusOnOpen && this.props.open) {
      this._focus();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.props.noFocusOnOpen && this.props.open && !prevProps.open) {
      this._focus();
    }
  }

  _focus() {
    // Buttons that opened Dialogs were becoming the active element instead of
    // the child wrapper. By delaying our focus call, this seems to be fixed.
    setTimeout(() => {
      if (this._childWrapper != null) {
        this._childWrapper.focus();
      }
    }, 0);
  }

  _handleBackButtonPressed = () => {
    const { onRequestClose } = this.props;
    if (onRequestClose != null) {
      onRequestClose();
      return { handled: true };
    } else {
      return { handled: false };
    }
  };

  render() {
    const {
      children,
      style,
      onTapBackground,
      open,
      docked,
      noCloseButton,
    } = this.props;

    const childWrapperStyle = {
      position: "relative", // closeButton is relative to this div
      boxShadow:
        "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.4)",
      backgroundColor: "white",
      ...(docked && {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
      }),
      zIndex: Theme.zIndexLayers.MODAL,
      ...style,
    };

    return open ? (
      <MountOnBody>
        <div style={styles.root} data-component-section="dialog-root">
          <BackButtonResponder onPressed={this._handleBackButtonPressed} />
          <DialogBackground
            open
            onTap={onTapBackground}
            aria-label="Close dialog"
          />
          <div
            data-component-name="Dialog"
            style={childWrapperStyle}
            tabIndex="-1"
            ref={(el) => (this._childWrapper = el)}
          >
            {children}
            {!noCloseButton && onTapBackground && !docked ? (
              <Tappable onTap={onTapBackground}>
                {({ active, tapTargetRefHandler }) => (
                  <NoStyleButton
                    style={styles.closeButtonWrapper}
                    innerRef={tapTargetRefHandler}
                    aria-label="close dialog"
                  >
                    <Button theme="round" forceActiveStyling={active}>
                      <IconClose style={styles.closeIcon} />
                    </Button>
                  </NoStyleButton>
                )}
              </Tappable>
            ) : null}
          </div>
        </div>
      </MountOnBody>
    ) : null;
  }
}

export { DialogBackground };



// WEBPACK FOOTER //
// ../nx-components/src/Dialog/index.jsx